export enum TimeLineListSortBy {
    None = 0,
    ClientNameAsc = 1,
    ClientNameDesc = 2,
    TimeSpentAsc = 3,
    TimeSpentDesc = 4,
    TypeAsc = 5,
    TypeDesc = 6,
    CreatedAsc = 7,
    CreatedDesc = 8
  }